import api from '../config/axios';

export default async function updateUserSettings(token, payload) {
  try {
    const response = await api.put('/settings/search', payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (err) {
    const msg =
      err?.response?.data?.message ||
      err?.response?.data ||
      err.message ||
      'Request failed';

    throw new Error(msg);
  }
}
